export default { initialize(){}, connectToDevTools(){} };